module.exports = __webpack_public_path__ + "pc/img/swiper_00.e066611b.jpg";